document.addEventListener('DOMContentLoaded', function() {
    const sizeDetails = {
  "us2": {'cm':{'b':'83','w':'65','h':'91','len':'150'},'in':{'b':'32 ½','w':'25 ½','h':'35 ¾','len':'59'}},
  "us4": {'cm':{'b':'85','w':'68','h':'93','len':'150'},'in':{'b':'33 ½','w':'26 ½','h':'36 ¾','len':'59'}},
  "us6": {'cm':{'b':'88','w':'70','h':'96','len':'152'},'in':{'b':'34 ½','w':'27 ½','h':'37 ¾','len':'60'}},
  "us8": {'cm':{'b':'90','w':'72','h':'98','len':'152'},'in':{'b':'35 ½','w':'28 ½','h':'38 ¾','len':'60'}},
  "us10": {'cm':{'b':'93','w':'75','h':'101','len':'152'},'in':{'b':'36 ½','w':'29 ½','h':'39 ¾','len':'60'}},
  "us12": {'cm':{'b':'97','w':'79','h':'106','len':'152'},'in':{'b':'38','w':'31','h':'41 ¾','len':'60'}},
  "us14": {'cm':{'b':'100','w':'83','h':'109','len':'155'},'in':{'b':'39 ½','w':'32 ½','h':'42 ¾','len':'61'}},
  "us16": {'cm':{'b':'104','w':'86','h':'114','len':'155'},'in':{'b':'41','w':'34','h':'44 ¾','len':'61'}},
  "us18": {'cm':{'b':'114','w':'98','h':'121','len':'155'},'in':{'b':'45','w':'38 ½','h':'47 ½','len':'61'}},
  "us20": {'cm':{'b':'119','w':'104','h':'126','len':'158'},'in':{'b':'47','w':'40 ¾','h':'49 ½','len':'62'}},
  "us22": {'cm':{'b':'124','w':'109','h':'131','len':'158'},'in':{'b':'49','w':'43','h':'51 ½','len':'62'}}
};

    var sizeHTML = `
      <div id="product-sizedetai-info"></div>
      <div id="t4s-product-custom-size-wrapper" class="t4s-product-custom-size-wrapper" style="display:none; margin-top: 1.5rem;">        
        <!-- 尺寸输入区域 -->
        <div id="custom-size-box" style="margin-top: 12px; border: 1px solid #eee; padding: 12px; border-radius: 4px;">

          <p style="margin-bottom: 8px; font-weight: 600;">
            Custom measurements：
          </p>

          <!-- 单位选择 -->
          <div id="custom-unit-box" style="margin-bottom: 10px; width:300px;">
            <label style="font-weight:600;">Unit：</label>
            <select id="custom-unit-select" name="properties[Unit]" style="padding:4px 10px;">
              <option value="cm" selected>Centimeters (cm)</option>
              <option value="inch">Inches (inch)</option>
            </select>
          </div>

          <div class="custom-size-grid" style="display:grid; grid-template-columns:repeat(auto-fit,minmax(140px,200px)); gap:8px 12px;">
            <div class="field">
              <label>Bust</label>
              <input id="customsizebust" class="cs-field" data-field="Bust" type="number" name="properties[Bust]" placeholder="e.g. 88 cm" />
            </div>

            <div class="field">
              <label>Waist</label>
              <input id="customsizewaist" class="cs-field" data-field="Waist" type="number" name="properties[Waist]" placeholder="e.g. 68 cm" />
            </div>

            <div class="field">
              <label>Hip</label>
              <input id="customsizehip" class="cs-field" data-field="Hip" type="number" name="properties[Hip]" placeholder="e.g. 94 cm" />
            </div>

            <div class="field">
              <label>Hollow to Floor</label>
              <input id="customsizehtf" class="cs-field" data-field="Hollow to Floor" type="number" name="properties[Hollow to Floor]" placeholder="e.g. 150 cm" />
            </div>
        </div>
        <p style="font-size: 12px; color: #777; margin-top: 8px;">
          * Please provide accurate measurements. We will tailor the dress accordingly.
        </p>
      </div>
    `;

    const optionButtons = document.querySelectorAll("div.is-t4s-name__size .t4s-swatch__item");

    const sizewrapper = document.querySelector('.t4s-swatch__option.is-t4s-name__size');
    if(!!sizewrapper){
      sizewrapper.insertAdjacentHTML("afterend", sizeHTML);
      var detailBox = document.querySelector("#product-sizedetai-info");

      var customSizeWrapper = document.querySelector('#t4s-product-custom-size-wrapper');
      var unitSelect = document.querySelector('#custom-unit-select');

      var csBustEl = document.querySelector('#customsizebust');
      var csWaistEl = document.querySelector('#customsizewaist');
      var csHipEl = document.querySelector('#customsizehip');
      var csHtFEl = document.querySelector('#customsizehtf');

      var sizeInputs = document.querySelectorAll('.cs-field');

      function updatePlaceholders() {
        var unit = unitSelect.value;
        sizeInputs.forEach(function(input) {
          var field = input.dataset.field;
          input.placeholder = unit === "cm"
            ? `e.g. 88 cm`
            : `e.g. 34 inch`;
        });
      }
      unitSelect.addEventListener('change', updatePlaceholders);

      setTimeout(function(){
        var defel = '';
        optionButtons.forEach(button => {
          if(button.classList.contains('is--selected'))defel=button;
          
          button.addEventListener('click', () => {
            const selectedText = button.dataset.value.toLowerCase();
            var detail = sizeDetails[selectedText] ;
            if(!detail){
              detail = sizeDetails['us'+selectedText];
            }
            
            if (detail) {
              var tabtxt = '<table style="width:100%;text-align: center;"><tr style="background-color:#f4f1de;"><th>Size: '+selectedText.toUpperCase()+'</th><th>Bust</th><th>Waist</th><th>Hips</th><th width="25%">Hollow to Floor</th></tr><tr><td>IN</td><td>'+detail['in']['b']+'</td><td>'+detail['in']['w']+'</td><td>'+detail['in']['h']+'</td><td>'+detail['in']['len']+'</td></tr><tr><td>CM</td><td>'+detail['cm']['b']+'</td><td>'+detail['cm']['w']+'</td><td>'+detail['cm']['h']+'</td><td>'+detail['cm']['len']+'</td></tr></table>';
              detailBox.innerHTML = tabtxt;

              unitSelect.value='cm'
              csBustEl.value=detail['cm']['b'];
              csWaistEl.value=detail['cm']['w'];
              csHipEl.value=detail['cm']['h'];
              csHtFEl.value=detail['cm']['len'];

              detailBox.style.display = "block";
            } else {
              csBustEl.value='';
              csWaistEl.value='';
              csHipEl.value='';
              csHtFEl.value='';
              detailBox.style.display = "none";
            }

            if (selectedText === "custom size" || selectedText === "custom") {
              customSizeWrapper.style.display = "block";
            } else {
              customSizeWrapper.style.display = "none";
            }
          });
        });

        if(defel)defel.click();
      }, 1000);
    }
 
});